<div class="page-wrapper">

    <app-bees-header></app-bees-header>

    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div>
    </div>



    <!-- PAGE HEADER -->

    <section class="page-header">

        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>

        <div class="container">

            <div class="page-header__inner">

                <div class="page-header__img-1">
                    <img src="assets/images/resources/page-header-img-1.png" alt="">
                </div>

                <div class="page-header__shape-1 float-bob-y">
                    <img src="assets/images/shapes/page-header-shape-1.png" alt="">
                </div>

                <h3>Agricultural Products
                </h3>

                <div class="thm-breadcrumb__inner">

                    <ul class="thm-breadcrumb list-unstyled">

                        <li>
                            <a href="index.html">Home</a>
                        </li>

                        <li>
                            <span class="fas fa-angle-right"></span>
                        </li>

                        <li>
                            <a href="services.html">Products</a>
                        </li>

                        <li>
                            <span class="fas fa-angle-right"></span>
                        </li>

                        <li> Agricultural Products
                        </li>

                    </ul>

                </div>

            </div>

        </div>

    </section>



    <!-- SERVICE DETAILS -->

    <section class="service-details">
        <div class="container">
            <div class="row"> <!-- LEFT SIDEBAR -->
                <div class="col-xl-4 col-lg-5">
                    <div class="service-details__sidebar">
                        <div class="service-details__services-box">
                            <h3 class="service-details__services-title">Agricultural Products
                            </h3>
                            <ul class="service-details__services-list list-unstyled">
                                <li [class.active]="activeSection === 'cashew'"> <a (click)="goToSection('cashew')">
                                        Cashew Nuts
                                        <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'cardamom'"> <a (click)="goToSection('cardamom')">
                                        Rice <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'cinnamon'"> <a (click)="goToSection('cinnamon')">
                                        Other Agricultural Products <span class="icon-next"></span> </a> </li>
                            </ul>
                        </div>
                        <div class="service-details__sidebar-contact">
                            <div class="service-details__sidebar-contact-img">
                                <div class="inner"> <img src="assets/images/services/service-details-sidebar-img.png"
                                        alt=""> </div>
                            </div>
                            <div class="service-details__sidebar-contact-content">
                                <div class="icon"> <span class="icon-phone-call"></span> </div>
                                <h2> <a href="tel:9447117399">+91 944 7117 399 </a> </h2>
                                <h2 style="color:#fd5523;"> If You Need Any Help <br> Contact With Us </h2>
                            </div>
                        </div>
                    </div>
                </div> <!-- RIGHT CONTENT -->
                <div class="col-xl-8 col-lg-7">
                    <div class="service-details__left"> <!-- PEPPER -->
                        <div *ngIf="activeSection === 'cashew'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-12.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Cashew Nuts
                            </h3>
                            <p class="service-details__text-1"> Cashew nuts are nutrient- dense powerhouses that support
                                heart health by lowering ‘bad’(ldl) cholesterol, aid weight management through high
                                protein and Fiber content and promote strong bones with magnesium and phosphorus. They
                                are rich in anti- orxidents and copper, supporting immune function, skin health and
                                brain function. Cashew nuts improve male fertility by enhancing sperm parameters
                                including count, motility and viability, primarily due to their high zinc and
                                antioxidant content. Regularly eating cashew nuts helps raise testosterone levels,
                                protects against oxidative stress and boosts overall reproductive health. They are
                                considered as a beneficial addition to a fertility- focused diet. It is available in
                                200,500,1000 grams sealed packets. </p>
                        </div> <!-- CARDAMOM -->
                        <div *ngIf="activeSection === 'cardamom'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-13.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Rice </h3>
                            <p class="service-details__text-1"> Double boiled dried rice,best quality for digestion are
                                available in 1,2,5 kg sealed packets. </p>
                        </div> <!-- CINNAMON -->
                        <div *ngIf="activeSection === 'cinnamon'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-14.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Other Agricultural Products </h3>
                            <p class="service-details__text-1">All other Kerala agricultural Products including yam,
                                elephant foot yam, colocessia,Chinese potato, sweet potato, tapioccia, banana etc.
                                available according to prescribed packings.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <app-bees-footer></app-bees-footer>

</div>



<div class="lock-popup"
     *ngIf="showPopup">

    <div class="popup-box">

        <h3>

            Enter Access Code

        </h3>

        <div class="pin-box">

            <input #p1
                   maxlength="1"
                   [(ngModel)]="pin1"
                   (input)="moveNext($event,p2)">

            <input #p2
                   maxlength="1"
                   [(ngModel)]="pin2"
                   (input)="moveNext($event,p3)">

            <input #p3
                   maxlength="1"
                   [(ngModel)]="pin3"
                   (input)="moveNext($event,p4)">

            <input #p4
                   maxlength="1"
                   [(ngModel)]="pin4"
                   (input)="moveNext($event)">

        </div>

        <p class="error"
           *ngIf="errorMsg">

            {{errorMsg}}

        </p>

    </div>

</div>

<div *ngIf="!showPopup">

    <!-- EXISTING PAGE -->

</div>